import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import EFVideo from '@/components/UI/EFVideo';

export default function D() {
    const { useEffect, useLang, useRef } = useGlobal();
    const { t } = useLang('xstream');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        new ScrollMagic.Scene({
            triggerElement: '.xstream .section-5 .title',
            triggerHook: 1,
            offset: 200,
            duration: 200,
        })
            .setTween(TweenMax.to('.xstream .section-5 .title', 0.5, { opacity: 1 }))
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.xstream .section-5 .desc',
            triggerHook: 1,
            offset: 150,
            duration: 200,
        })
            .setTween(TweenMax.to('.xstream .section-5 .desc', 0.5, { opacity: 1 }))
            .addTo(controller);
    }, []);

    const v4Ref = useRef(null);
    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        const video4El = document.querySelector('.xstream_D .section-5 #xstream-video4') as HTMLElement;
        new ScrollMagic.Scene({
            triggerElement: '.xstream .section-5 .video-wrapper',
            triggerHook: 1,
        })
            .on('enter', () => {
                if (video4El) {
                    video4El.currentTime = 0;
                }
            })
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.xstream .section-5 .video-wrapper',
            triggerHook: 1,
            offset: layoutH * 0.6,
        })
            .on('enter', () => {
                v4Ref?.current?.play();
            })
            .addTo(controller);
    }, []);

    return (
        <div className={`xstream_D ${css.xstream_D}`}>
            <div className="section-5">
                <div className="video-wrapper video4">
                    <EFVideo
                        id="xstream-video4"
                        sources={['/media/x-stream/pc/05.webm', '/media/x-stream/pc/05.mp4']}
                        ref={v4Ref}
                        loop={false}
                        autoPlay={false}
                    />
                </div>
                <div className="mask"></div>
                <div className="text-wrapper">
                    <div className="title">{t('section_5_title')}</div>
                    <div className="desc">{t('section_5_desc')}</div>
                </div>
            </div>
        </div>
    );
}
